import dayjs from "dayjs";
import {
  AppointmentStatus,
  DateRangeOptions,
  MainMenu,
  PrescriptionTypes,
  RouteAccess,
  AvailablePrescriptionTypes,
} from "./Constants";
import { useEffect, useRef } from "react";

export function convertTime(time) {
  var splitTime = time.split(":");
  var ampm = splitTime[0] > 11 ? "PM" : "AM";
  var hr = splitTime[0];
  if (hr > 12 && ampm === "PM") {
    hr = splitTime[0] % 12;
  }
  return hr + ":" + splitTime[1] + " " + ampm;
}

export function getDisplayValue(text) {
  var displayText = "";
  switch (text) {
    case AppointmentStatus.InProgress:
      displayText = "In Progress";
      break;
    case AppointmentStatus.CheckedIn:
      displayText = "Checked In";
      break;
    case AppointmentStatus.NoShow:
      displayText = "No Show";
      break;
    case DateRangeOptions.Last30Days:
      displayText = "Last 30 Days";
      break;
    case DateRangeOptions.Next30Days:
      displayText = "Next 30 Days";
      break;
    case DateRangeOptions.Next7Days:
      displayText = "Next 7 Days";
      break;
    case DateRangeOptions.Last7Days:
      displayText = "Last 7 Days";
      break;
    case MainMenu.billing:
      displayText = "Billing";
      break;
    case MainMenu.myWorklist:
      displayText = "Tasks";
      break;
    case MainMenu.mySettings:
      displayText = "My Settings";
      break;
    case MainMenu.facilitySettings:
      displayText = "Settings";
      break;
    case PrescriptionTypes.GeneralPrescription:
      displayText = "General Prescription";
      break;
    case PrescriptionTypes.PhysiotherapyPrescription:
      displayText = "Physiotherapy Prescription";
      break;
    case PrescriptionTypes.DentalPrescription:
      displayText = "Dental Prescription";
      break;
    case PrescriptionTypes.PathologyLabReport: // Add this case
      displayText = "Pathology Lab Report";
      break;
    case PrescriptionTypes.FrozenShoulder: // Add this case
      displayText = "Frozen Shoulder";
      break;
    // case "PhysiotherapyTreatment":
    //   displayText = "Physiotherapy Treatment";
    //   break;
    case "NotStarted":
      displayText = "Not Started";
      break;
    case "Asia/Kolkata":
      displayText = "IST";
      break;
    case "CreditCard":
      displayText = "Credit Card";
      break;
    case "DebitCard":
      displayText = "Debit Card";
      break;
    case "NetBanking":
      displayText = "Net Banking";
      break;
    case "AccountTransfer":
      displayText = "Account Transfer";
      break;
    case "CreditNote":
      displayText = "Credit Note";
      break;
    case "FacilityAdmin":
      displayText = "Facility Admin";
      break;
    case "FrontDesk":
      displayText = "Front Desk";
      break;
    case "LabTechnician":
      displayText = "Lab Technician";
      break;
    case "InventoryManager":
      displayText = "Inventory Manager";
      break;
    // Notes & Records display test for workItemDetail
    case "General":
      displayText = "General Notes";
      break;
    case "PhysiotherapyTreatment":
      displayText = "Physio Notes";
      break;
    case "Medical History":
      displayText = "Medical Record";
      break;  
    default:
      displayText = text;
      break;
  }
  return displayText;
}

export function useDebouncedEffect(effect, deps, delay) {
  const handler = useRef();
  useEffect(() => {
    if (handler.current) clearTimeout(handler.current);
    handler.current = setTimeout(effect, delay);
    return () => clearTimeout(handler.current);
    // eslint-disable-next-line
  }, [...deps, delay]);
}

export function calculateAge(dateValue) {
  if (dateValue) {
    const today = dayjs();
    const birthDate = dayjs(dateValue);
    const years = today.diff(birthDate, "year");
    const months = today.diff(birthDate.add(years, "year"), "month");
    const ageInYears = `${years} years ${months} months`;
    return ageInYears;
  }
}

export function showLoadingImage() {
  return (
    <div class="col-12 d-flex justify-content-center">
      <img
        src="./Animated_icon_clockwise.gif"
        height={50}
        width={50}
        alt="loading"
      ></img>
    </div>
  );
}

export function showSmallLoadingImage() {
  return (
    <img
      src="./Animated_icon_clockwise.gif"
      height={20}
      width={20}
      alt="loading"
    ></img>
  );
}

export const capitalizeFirstLetter = (str) => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
};

export const formatAge = (ageInYears) => {
  if (!ageInYears) return "N/A";

  const years = Math.floor(ageInYears);
  const months = Math.floor((ageInYears - years) * 12);

  return months > 0 ? `${years} Yrs ${months} M` : `${years} Yrs`;
};

export function calculateAgeOnlyYear(dateValue) {
  if (dateValue) {
    const today = dayjs();
    const birthDate = dayjs(dateValue);
    const years = today.diff(birthDate, "year");
    return Number(years);
  }
}
export const numberToWords = (num) => {
  if (num === 0) return "Zero"; // Base case for 0

  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const scales = ["", "Thousand", "Lakh", "Crore"];

  let words = [];
  let scaleIndex = 0;

  num = Math.round(num); // Round to remove decimals

  while (num > 0) {
    let part = num % 1000; // Extract last 3 digits

    if (part > 0) {
      let partWords = convertThreeDigitNumber(part, units, teens, tens);
      words.unshift(
        partWords + (scales[scaleIndex] ? " " + scales[scaleIndex] : ""),
      );
    }

    num = Math.floor(num / 1000); // Remove last 3 digits
    scaleIndex++;
  }

  return words.join(" ").trim();
};

// Converts a three-digit number into words
export const convertThreeDigitNumber = (num, units, teens, tens) => {
  let words = [];

  if (num >= 100) {
    words.push(units[Math.floor(num / 100)] + " Hundred");
    num %= 100;
  }

  if (num >= 10 && num < 20) {
    words.push(teens[num - 10]); // Special case for 10-19
  } else if (num >= 20 || num === 10) {
    words.push(tens[Math.floor(num / 10)]);
    num %= 10;
  }

  if (num > 0 && num < 10) {
    words.push(units[num]);
  }

  return words.join(" ");
};

export const canAccess = ({ route, roles }) => {
  return roles?.some((role) => RouteAccess[route].includes(role)) || false;
};

// get label from AvailablePrescriptionTypes by its value
export const getLabelOfPrescriptionTypes = (value) => {
  const found = AvailablePrescriptionTypes.find((item) => item.value === value);
  return found ? found.label : null; // returns null, if not found
};
